import { render, staticRenderFns } from "./BuildingLink.vue?vue&type=template&id=36c2af7c&scoped=true&"
import script from "./BuildingLink.vue?vue&type=script&lang=js&"
export * from "./BuildingLink.vue?vue&type=script&lang=js&"
import style0 from "./BuildingLink.vue?vue&type=style&index=0&id=36c2af7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2af7c",
  null
  
)

export default component.exports